import { useContext } from "react";
import { FormattedMessage } from "react-intl";

import Button from "@components/buttons/Button";
import ClientVisibleTaskResourceUsefulnessButtons from "@components/ClientVisibleTaskResourceUsefulnessButtons";
import { openerContext } from "@context/Contexts";
import { OpenerTypeEnum } from "@typing/Enums";
import { ResourceFragment } from "@typing/Generated";

type Props = {
  className?: string;
  resource: ResourceFragment;
  updateUseful: (resource: ResourceFragment, useful: boolean) => void;
};

const ClientVisibleTaskResourceActions = ({ className, resource, updateUseful }: Props) => {
  const { toggleOpener } = useContext(openerContext);

  const classNames = ["flex", "items-center", "justify-center", "gap-lg", "margin-10-top", "full-width"];
  if (className) classNames.push(className);

  return (
    <div className={classNames.join(" ")}>
      <div className="flex-grow ion-hide-md-down">
        <Button onClick={() => toggleOpener(OpenerTypeEnum.MESSAGES, true, resource)}>
          <FormattedMessage id="components.ClientVisibleTaskResourceActions.cta" />
        </Button>
      </div>
      <ClientVisibleTaskResourceUsefulnessButtons resource={resource} updateUseful={updateUseful} />
    </div>
  );
};

export default ClientVisibleTaskResourceActions;
